import { Link, useParams } from "react-router-dom";
import { format } from "date-fns";
import { it, enUS, fr } from "date-fns/locale";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const LOCALES = { it, en: enUS, fr };

const POST_IMAGES = {
  "naturopatia-cosa-e": "https://images.pexels.com/photos/5480036/pexels-photo-5480036.jpeg",
  "massaggio-olistico-benefici": "https://images.pexels.com/photos/6628646/pexels-photo-6628646.jpeg",
  "prevenzione-stagionale": "https://images.unsplash.com/photo-1545048702-79362596cdc9?w=1200",
  "integratori-naturali-quando": "https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=1200",
};

export default function BlogPost() {
  const { slug } = useParams();
  const { t, i18n } = useTranslation();
  const locale = LOCALES[i18n.resolvedLanguage] || it;
  const posts = t("blog.posts", { returnObjects: true });
  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-24 text-center">
        <h1 className="font-serif text-4xl">{t("blog.notFound")}</h1>
        <Link to="/blog" className="btn-secondary mt-8 inline-flex">{t("blog.backToBlog")}</Link>
      </div>
    );
  }

  return (
    <article data-testid="page-blog-post" className="max-w-3xl mx-auto px-5 sm:px-8 py-16 lg:py-24">
      <Link to="/blog" data-testid="blog-back" className="inline-flex items-center gap-2 text-sm text-[#5C6356] hover:text-[#8A9A86] transition-colors">
        <ArrowLeft size={16} strokeWidth={1.5} /> {t("blog.back")}
      </Link>
      <div className="mt-8 label-eyebrow">{post.category} · {post.read_time}</div>
      <h1 className="font-serif text-5xl sm:text-6xl leading-[1.05] text-[#2C2F2A] mt-4">{post.title}</h1>
      <div className="text-sm text-[#5C6356] mt-4">{format(new Date(post.date), "d MMMM yyyy", { locale })}</div>
      <img src={POST_IMAGES[post.slug]} alt={post.title} className="w-full h-[420px] object-cover rounded-[2rem] mt-10" />
      <div className="mt-10 space-y-6 text-lg text-[#2C2F2A] leading-relaxed whitespace-pre-line">
        {post.content}
      </div>
      <div className="mt-16 p-8 bg-[#F3F0EA] rounded-[2rem] text-center">
        <h3 className="font-serif text-3xl">{t("blog.ctaTitle")}</h3>
        <p className="text-[#5C6356] mt-3">{t("blog.ctaText")}</p>
        <Link to="/prenotazioni" data-testid="post-cta" className="btn-primary mt-6 inline-flex">{t("blog.ctaButton")}</Link>
      </div>
    </article>
  );
}
